import { api } from "./api.js";

/**
 * Profile & account endpoints (`/api/profile`).
 *
 * The backend enforces the role rules (staff may only edit personal fields and
 * can never change their own password); this module is a thin transport layer.
 */

/** GET /api/profile/me — full personal profile + linked employee details. */
export const me = () => api.get("/profile/me");

/** PUT /api/profile/me — update allowed personal fields. */
export const updateMe = (payload) => api.put("/profile/me", payload);

/** PUT /api/profile/change-password — admin only. */
export const changePassword = (payload) => api.put("/profile/change-password", payload);

/** GET /api/profile/staff-accounts — admin only. */
export const listStaffAccounts = () => api.get("/profile/staff-accounts");

/** PUT /api/profile/staff-accounts/:userId/password — admin only. */
export const resetStaffPassword = (userId, payload) =>
  api.put(`/profile/staff-accounts/${userId}/password`, payload);

/** GET /api/profile/salon-business — admin only. */
export const getSalonBusiness = () => api.get("/profile/salon-business");

/** PUT /api/profile/salon-business — admin only. */
export const updateSalonBusiness = (payload) => api.put("/profile/salon-business", payload);

export default {
  me,
  updateMe,
  changePassword,
  listStaffAccounts,
  resetStaffPassword,
  getSalonBusiness,
  updateSalonBusiness,
};
